module.exports = __webpack_public_path__ + "img/装箱机.3757e2ef.jpg";